import Button from "@/components/button";

export default function CallToActionButton(props) {
  return (
    <Button target="_blank" rel="noopener noreferrer" {...props}>
      {props.children}
    </Button>
  );
}
